import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";

import { PeriodicNotificationModel } from "@app/mailmessages/models/periodicNotificationModel";
import { PeriodicNotificationIncidentModel } from "@app/mailmessages/models/periodicNotificationIncidentModel";

@Injectable({
    providedIn: "root",
})
export class IncidentPeriodicNotificationService {
    private httpClient: HttpClient = inject(HttpClient);
    private baseUrl = `${localStorage.getItem("incidentUrl")}/api/periodic-notifications`;

    public getIncidentNotifications(): Observable<PeriodicNotificationModel[]> {
        return this.httpClient.get<PeriodicNotificationModel[]>(this.baseUrl);
    }

    public getNotification(id: string): Observable<PeriodicNotificationIncidentModel> {
        return this.httpClient.get<PeriodicNotificationIncidentModel>(`${this.baseUrl}/${id}`);
    }

    public saveNotification(notification: PeriodicNotificationModel): Observable<string> {
        return this.httpClient.post<string>(this.baseUrl, notification);
    }

    public deleteNotification(id: string): Observable<void> {
        return this.httpClient.delete<void>(`${this.baseUrl}/${id}`);
    }

    public getStandingDataForNotification(): Observable<any> {
        return this.httpClient.get<any>(`${this.baseUrl}/standingdata`);
    }

    public getNotificationKeywords(): Observable<string[]> {
        return this.httpClient.get<string[]>(`${this.baseUrl}/keywords`);
    }
}
